// extracted by mini-css-extract-plugin
module.exports = {"sectionInfo":"OrderStream_sectionInfo___LpuK"};